import React from "react";
import { Box } from "@mui/material";
import { LeaderboardCard } from "./leaderboard-card/leaderboard-card";
import { AchievementCard } from "./achievement-card/achievement-card";
import { SalesModelTrainingCard } from "./sales-model-training-card/sales-model-training-card";

export const StatisticsRowTwo: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {/* <Box
        display={"flex"}
        gap={"16px"}
        sx={{ flexDirection: { xs: "column", md: "row" } }}
      >
        <Box
          sx={{
            flex: { xs: "unset", md: 2 },
            backgroundColor: "#FFFFFF",
            padding: "16px",
            borderRadius: "16px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <SalesModelTrainingCard />
        </Box>
        <Box
          sx={{
            flex: { xs: "unset", md: 1 },
            backgroundColor: "#FFFFFF",
            padding: "16px",
            borderRadius: "16px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <LeaderboardCard />
        </Box>
      </Box> */}
    </Box>
  );
};
